<template>
    <st-page
        :title="$t('DOCUMENT_SERIES_ALLOCATION.LIST.TITLE')"
    >
        <template #toolbar>
            <DocumentSeriesAllocationListToolbar @add="add"/>
        </template>
        <div v-if="initLoading">
            <DocumentSeriesAllocationListFilter ref="documentSeriesAllocationListFilter" >
                <DocumentSeriesAllocationListTable @view="view" @update="update">
                </DocumentSeriesAllocationListTable>
            </DocumentSeriesAllocationListFilter>
        </div>
        <SelectOrganisationModal
            ref="selectOrganisationModal"
            @organisationSelected="organisationSelected"
        ></SelectOrganisationModal>
        <ManageDocumentSeriesAllocationModal
            ref="documentSeriesAllocationModal"
            @update="update"
        ></ManageDocumentSeriesAllocationModal>
    </st-page>
</template>
<script>
import DocumentSeriesAllocationListFilter from '@/modules/document-series-allocation/components/DocumentSeriesAllocationListFilter';
import DocumentSeriesAllocationListTable from '@/modules/document-series-allocation/components/DocumentSeriesAllocationListTable';
import DocumentSeriesAllocationListToolbar from '@/modules/document-series-allocation/components/DocumentSeriesAllocationListToolbar';
import ManageDocumentSeriesAllocationModal from '@/modules/document-series-allocation/components/ManageDocumentSeriesAllocationModal.vue';
import SelectOrganisationModal from '@/modules/administrator/components/modals/SelectOrganisationModal.vue';
import Roles from '@/security/roles';
import { mapGetters } from "vuex";

export default {
    name: "DocumentSeriesAllocationList",
    components: {
        DocumentSeriesAllocationListFilter,
        DocumentSeriesAllocationListTable,
        DocumentSeriesAllocationListToolbar,
        ManageDocumentSeriesAllocationModal,
        SelectOrganisationModal,
    },
    data() {
        return {
            initLoading: false,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'shared/loading',
            organisation: 'administrator/institution',
            currentUser: 'auth/currentUser',
            downloadAccessToken: "documentSeriesAllocation/list/downloadAccessToken",
        }),
        isSuperAdmin() {
            return this.currentUser.user_type_name === Roles.values['super_admin']
        }
    },
    methods: {
        async organisationSelected() {
            this.$refs.selectOrganisationModal.hide();
            this.initLoading = true;
        },
        add() {
            this.$refs.documentSeriesAllocationModal.show();
        },
        view(id) {
            window.open(`${window.VUE_APP_API_URL}/files/${id}?token=${this.downloadAccessToken}`, '_blank');
        },
        update() {
            this.$refs.documentSeriesAllocationListFilter.refresh();
        }
    },
    mounted() {
       if (this.isSuperAdmin) {
            this.initLoading = false;
            this.$refs.selectOrganisationModal.show();
        } else {
            this.initLoading = true;
        }
    },
};
</script>
<style scoped>

</style>


